import React from 'react'
import StartCareForm from '../components/StartCareForm';

const Inquiry = () => {
  return (
    <div>
        <div className='row-justify-content-between grey'>
            <h1>Inquire About Our Services</h1>
        </div>
        <StartCareForm />
    </div>
  )
}

export default Inquiry